// src/screens/tabs/Menu/components/MenuItemCard.tsx
import React from "react";
import { View, Text, Image } from "react-native";
import { ToggleLeft } from "lucide-react-native";
import { MenuItemType } from "../../types/restaurant.types";
import { menuScreenStyles as styles } from "../../styles/styles";
import { FlickOColors } from "../../styles/color";
import { getResponsiveSize } from "../../styles/globalStyles";
import { config } from "../../../../config";
import { cs } from "../../constant";
import MenuItemImage from "../../../../screens/MenuItemImage";

interface MenuItemCardProps {
  item: MenuItemType;
  isLastItem: boolean;
  onAddToCart: (item: MenuItemType, quantity: number) => void;
}

export const MenuItemCard: React.FC<MenuItemCardProps> = ({
  item,
  isLastItem,
  onAddToCart,
}) => {
  return (
    <View>
      <View style={styles.menuItemCard}>
        <View style={styles.contentSection}>
          <View style={styles.typeIconContainer}>
            {item.foodType === "veg" && (
              <View style={[styles.foodTypeIcon, styles.vegIcon]}>
                <View
                  style={[
                    styles.innerDot,
                    { backgroundColor: styles.vegIcon.borderColor },
                  ]}
                />
              </View>
            )}
            {item.foodType === "egg" && (
              <View style={[styles.foodTypeIcon, styles.eggIcon]}>
                <Text style={styles.eggText}>🥚</Text>
              </View>
            )}
            {item.foodType === "non-veg" && (
              <View style={[styles.foodTypeIcon, styles.nonVegIcon]}>
                <View
                  style={[
                    styles.innerDot,
                    { backgroundColor: styles.nonVegIcon.borderColor },
                  ]}
                />
              </View>
            )}
          </View>

          <Text numberOfLines={2} style={styles.itemName}>
            {item.name}
          </Text>

          <View style={styles.ratingContainer}>
            {[1, 2, 3, 4, 5].map((star) => (
              <Text key={star} style={styles.star}>
                {star <= 4 ? "★" : "☆"}
              </Text>
            ))}
            <Text style={styles.ratingCount}>(342)</Text>
          </View>

          <Text style={styles.price}>₹{item.price}</Text>
          <Text numberOfLines={3} style={styles.description}>
            {item.description}
          </Text>

          {config.app.name === cs.partnerApp && (
            <View
              style={[
                styles.toggleButton,
                item.isEnabled && styles.toggleButtonEnabled,
                { marginTop: getResponsiveSize(8) },
              ]}
            >
              <ToggleLeft
                size={20}
                color={
                  item.isEnabled
                    ? FlickOColors.success
                    : FlickOColors.text.secondary
                }
              />
              <Text
                style={[
                  styles.toggleText,
                  item.isEnabled && styles.toggleTextEnabled,
                ]}
              >
                {item.isEnabled ? "In Stock" : "Out Of Stock"}
              </Text>
            </View>
          )}
        </View>

        <MenuItemImage item={item} onAddToCart={onAddToCart} />
        {/* <Image
          source={
            item.imageUrl
              ? { uri: item.imageUrl }
              : require("../../../../../assets/pavBhaji.jpeg")
          }
          style={styles.itemImage}
          resizeMode="contain"
        /> */}
      </View>
      {!isLastItem && (
        <View style={[styles.divider, { marginTop: getResponsiveSize(20) }]} />
      )}
    </View>
  );
};
